import styled from 'styled-components';

import { useTranslate } from '@dreryk/react-common';
import { basicTitleTextStyle, fonts, RepeatIcon } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../translations';

type AvailabilityUpdateModalTitleProps = {
   readonly recurring: boolean;
};

const StyledAvailabilityUpdateModalTitleWrapper = styled.div`
   display: flex;
`;
StyledAvailabilityUpdateModalTitleWrapper.displayName = 'StyledAvailabilityUpdateModalTitleWrapper';

const StyledAvailabilityUpdateModalTitle = styled.span`
   ${basicTitleTextStyle};
   display: block;
   font-weight: ${fonts.fontWeightBold};
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
   margin-right: 0.4em;

   + svg {
      width: 1em;
      height: 1em;
   }
`;
StyledAvailabilityUpdateModalTitle.displayName = 'StyledAvailabilityUpdateModalTitle';

export const AvailabilityUpdateModalTitle = ({ recurring }: AvailabilityUpdateModalTitleProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <StyledAvailabilityUpdateModalTitleWrapper>
         <StyledAvailabilityUpdateModalTitle>
            {recurring
               ? translate(personnelTranslationKeys.updateRecurringWorkingTime)
               : translate(personnelTranslationKeys.updateWorkingTime)}
         </StyledAvailabilityUpdateModalTitle>
         {recurring ? <RepeatIcon /> : null}
      </StyledAvailabilityUpdateModalTitleWrapper>
   );
};
